
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/suport-clienti/cauta",
      function () {
        return require("private-next-pages/suport-clienti/cauta.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/suport-clienti/cauta"])
      });
    }
  